export default "__VITE_ASSET__DXF2GrQO__"